import * as React from 'react';
import VariantListItem from './VariantListItem';
import Section from './Section';
import { Variant } from '../product';

const activeVariants = (items: Variant[]) => {
  return items.filter((variant: Variant) => variant.in_stock);
};

const inactiveVariants = (items: Variant[]) => {
  return items.filter((variant: Variant) => !variant.in_stock);
};

const renderItem = (variant: Variant, index: number) => (
  <VariantListItem variant={variant} key={index} />
);

type Props = {
  items: Variant[];
};

export default function VariantsList(props: Props) {
  return (
    <React.Fragment>
      {activeVariants(props.items).length > 0 && (
        <Section title="In Stock">
          {activeVariants(props.items).map(renderItem)}
        </Section>
      )}
      {inactiveVariants(props.items).length > 0 && (
        <Section title="Out of Stock">
          {inactiveVariants(props.items).map(renderItem)}
        </Section>
      )}
    </React.Fragment>
  );
}
